import React, { useState, useEffect, useContext } from "react";
import "../../../css/CRUDModal.css";
import DeleteFranchiseConfirmationModal from "./DeleteFranchiseConfirmationModal";
import axios from "axios";
import { BankNameContext } from "../../../context/BankNameContext";
import CustomAlert from "../../../helpers/CustomAlert";
import { toast } from "react-toastify";
import {apiList, baseAuthUrl, baseUrl} from "../../../helpers/apiList";
import { axiosPostApi } from "../../../helpers/interceptorServices";

const CustomerModal = ({
  show,
  handleClose,
  editData,
  action,
  fetchCustomerData,
}) => {
  const loggedInUserName = sessionStorage.getItem("username");
  const [formData, setFormData] = useState({
    username: loggedInUserName,
    name: "",
    emailId: "",
    address1: "",
    address2: "",
    address3: "",
    city: "",
    state: "",
    pinCode: "",
    firstContactPersonName: "",
    firstContactPersonMobileNo: "",
    bankName: "",
    accountNo: "",
    ifscCode: "",
    rate: "",
  });
  const [errors, setErrors] = useState({
    name: "",
    emailId: "",
    address1: "",
    address2: "",
    pinCode: "",
    firstContactPersonName: "",
    firstContactPersonMobileNo: "",
    bankName: "",
    accountNo: "",
    ifscCode: "",
  });
  const { bankNames, loading, error } = useContext(BankNameContext);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (action === "add") {
      // Reset form data for adding a new customer
      setFormData({
        username: loggedInUserName,
        name: "",
        emailId: "",
        address1: "",
        address2: "",
        address3: "",
        city: "",
        state: "",
        pinCode: "",
        firstContactPersonName: "",
        firstContactPersonMobileNo: "",
        // secondContactPersonName: '',
        // secondContactPersonMobileNo: '',
        bankName: "",
        accountNo: "",
        ifscCode: "",
        rate: "",
      });
    } else if (
      action === "modify" ||
      action === "view" ||
      action === "delete"
    ) {
      // Pre-fill the form with editData
      setFormData({
        ...editData,
        username: loggedInUserName,
        state: editData?.state || "",
        city: editData?.city || "",
        bankName: editData?.bankName || "",
      });
    }
  }, [action, editData]);

  if (loading) {
    return <p>Loading data...</p>;
  }

  const handleInputChange = (e) => {
    const { id, value } = e.target;

    let updatedValue = value;

    if (id === "name" || id === "ifscCode") {
      updatedValue = value.toUpperCase();
    } else if (id === "emailId") {
      updatedValue = value.toLowerCase(); // Convert to lowercase
    } else if (
      id === "firstContactPersonMobileNo" ||
      id === "secondContactPersonMobileNo" ||
      id === "accountNo"
    ) {
      updatedValue = value.replace(/[^0-9]/g, ""); // Allow only digits
    }

    setFormData({ ...formData, [id]: updatedValue });

    if (id === "pinCode") {
      validatePinCode(value);
    }
  };

  // Simple validation function
  const validate = () => {
    const newErrors = {};

    // Name validation (between 2 and 50 characters)
    formData.name = formData.name.trim();
    if (!formData.name) {
      newErrors.name = "Company Name is required";
    } else if (
      !/^[A-Za-z]+(?: [A-Za-z]+)*$/.test(formData.name) ||
      formData.name.length < 2 ||
      formData.name.length > 50
    ) {
      newErrors.name =
        "Customer name must be valid and between 2 and 50 characters";
    }

    // Email validation (required and valid email)
    if (!formData.emailId) {
      newErrors.emailId = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.emailId)) {
      newErrors.emailId = "Email is invalid";
    }

    // Address validation
    if (!formData.address1) {
      newErrors.address1 = "Address is required";
    } else if (formData.address1.length < 5 || formData.address1.length > 50) {
      newErrors.address1 = "Address1 must be between 5 and 50 characters";
    }

    if (!formData.address2) {
      newErrors.address2 = "Address is required";
    } else if (formData.address2.length < 5 || formData.address2.length > 50) {
      newErrors.address2 = "Address2 must be between 5 and 50 characters";
    }

    if (!formData.pinCode) {
      newErrors.pinCode = "Pincode is required";
    } else if (!/^[1-9]\d{5}$/.test(formData.pinCode)) {
      newErrors.pinCode = "Pincode must be 6 digits and must not start with 0";
    }

    // First contact person name validation (between 2 and 50 characters)
    if (!formData.firstContactPersonName) {
      newErrors.firstContactPersonName =
        "First contact person name is required";
    } else if (
      !/^[A-Za-z]+(?: [A-Za-z]+)*$/.test(formData.firstContactPersonName) ||
      formData.firstContactPersonName.length < 2 ||
      formData.firstContactPersonName.length > 50
    ) {
      newErrors.firstContactPersonName =
        "First contact person name must be between 2 and 50 characters";
    }

    // Second contact person name validation (between 2 and 50 characters)
    // if (formData.secondContactPersonName && (!/^[A-Za-z]+(?: [A-Za-z]+)*$/.test(formData.secondContactPersonName) || formData.secondContactPersonName.length < 2 || formData.secondContactPersonName.length > 50)) {
    //   newErrors.secondContactPersonName = 'Second contact person name must be between 2 and 50 characters';
    // }

    // First contact person mobile number validation
    if (!formData.firstContactPersonMobileNo) {
      newErrors.firstContactPersonMobileNo =
        "First contact person mobile number is required";
    } else if (!/^[789]\d{9}$/.test(formData.firstContactPersonMobileNo)) {
      newErrors.firstContactPersonMobileNo =
        "Mobile number must be 10 digits and start with 7, 8, or 9";
    }

    // Second contact person mobile number validation
    // if (formData.secondContactPersonMobileNo && !/^\d{10}$/.test(formData.secondContactPersonMobileNo)) {
    //   newErrors.secondContactPersonMobileNo = 'Mobile number must be exactly 10 digits';
    // }

    // Bank Name validation
    if (!formData.bankName) {
      newErrors.bankName = "Bank Name is required";
    }

    // IFSC Code validation (must be 11 characters)
    if (!formData.ifscCode) {
      newErrors.ifscCode = "IFSC code is required";
    } else if (!/^[A-Z]{4}[0-9]{7}$/.test(formData.ifscCode)) {
      newErrors.ifscCode = "IFSC Code must be 4 alphabets followed by 7 digits";
    }

    // Rate validation (between values 0.01 to 0.99)
    if (!formData.rate) {
      newErrors.rate = "Rate is required";
    } else if (
      !/^(0\.[0-9]{1,2}|0\.0[1-9]|0\.[1-9][0-9])$/.test(formData.rate)
    ) {
      newErrors.rate = "Rate value must be between 0.01 to 0.99";
    }

    // Account Number validation (between digits 5 to 30)
    if (!formData.accountNo) {
      newErrors.accountNo = "Account Number is required";
    } else if (!/^[1-9]\d{4,29}$/.test(formData.accountNo)) {
      newErrors.accountNo =
        "Account Number must be 5 to 30 digits and must not start with 0";
    }

    return newErrors;
  };

  const validatePinCode = (pinCode) => {
    let newErrors = { ...errors };

    if (!pinCode) {
      newErrors.pinCode = "Pincode is required";
    } else if (!/^\d{6}$/.test(pinCode)) {
      newErrors.pinCode = "Pincode must be 6 digits";
    } else {
      delete newErrors.pinCode;

      axios
        .get(`${baseAuthUrl}/sms/pincode/${pinCode}`)
        .then((response) => {
          const { status, message, data } = response.data;

          if (!status || !data || data.length === 0) {
            newErrors.pinCode = message || "Enter a valid Pincode";
          } else {
            const pinCodeData = data[0];
            const { cityName, state } = pinCodeData;
            setFormData((prevFormData) => ({
              ...prevFormData,
              city: cityName,
              state,
            }));

            delete newErrors.pinCode;
          }
          setErrors(newErrors);
        })
        .catch((error) => {
          console.error("Error fetching pincode data:", error);
          newErrors.pinCode = "Error fetching pincode data";
          setErrors(newErrors);
        });
    }
  };

  const handleAddCustomer = (e) => {
    e.preventDefault();

    const validationErrors = validate();
    setErrors(validationErrors);

    // If there are no validation errors, proceed with the API call
    if (Object.keys(validationErrors).length === 0) {
      setIsSubmitted(true);

      let apiUrl = ""; // The API endpoint
      let successMessage = ""; // The message to show on success

      // Determine if the action is 'add' or 'modify'
      if (action === "add") {
        apiUrl = apiList.CREATE_FRANCHISE_MASTER; // Add customer API endpoint
        successMessage = "Franchise added successfully";
      } else if (action === "modify") {
        apiUrl = apiList.MODIFY_FRANCHISE_MASTER; // Modify customer API endpoint
        successMessage = "Franchise details modified successfully";
      }

      axiosPostApi(apiUrl, formData)
        .then((response) => {
          if (response.status === 200 && response.data.status === true) {
            // Show success toast notification
            toast.success(successMessage, {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            handleClose(); // Close the modal
            fetchCustomerData(1); // Refresh the customer data
          } else {
            // Show error message using custom alert
            CustomAlert({
              title:
                action === "add"
                  ? "Failed to Add Customer"
                  : "Failed to Modify Customer",
              text:
                response.data.message ||
                "There was an issue processing the request. Please try again.",
              icon: "error",
              confirmButtonText: "Retry",
            });
          }
        })
        .catch((error) => {
          console.error("Error processing customer request:", error);
          CustomAlert({
            title: "Error",
            text:
              action === "add"
                ? "An error occurred while adding the customer. Please try again later."
                : "An error occurred while modifying the customer. Please try again later.",
            icon: "error",
            confirmButtonText: "Retry",
          });
        });
    }
  };

  const isViewMode = action === "view";
  const isDeleteMode = action === "delete";
  const isEditMode = action === "modify";

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleBack = () => {
    handleClose();
    setErrors({});
  };

  return (
    <>
      <div
        className={`modal fade ${show ? "show" : ""}`}
        tabIndex="-1"
        role="dialog"
        style={{ display: show ? "block" : "none" }}
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title main-title">
                {action.charAt(0).toUpperCase() + action.slice(1)} Customer
                Details
              </h5>
            </div>

            <form onSubmit={(e) => handleAddCustomer(e)}>
              <div className="scoped-modal modal-body">
                <div className="row mb-3">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="name">
                        Customer Name<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Customer Name"
                        id="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        disabled={isViewMode || isDeleteMode}
                      />
                      {!(isViewMode || isDeleteMode) && errors.name ? (
                        <span className="error">{errors.name}</span>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="emailId">
                        Customer Email Id<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Enter Email Id"
                        id="emailId"
                        value={formData.emailId}
                        onChange={handleInputChange}
                        disabled={isViewMode || isDeleteMode}
                      />
                      {!(isViewMode || isDeleteMode) && errors.emailId ? (
                        <span className="error">{errors.emailId}</span>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="address1">
                        Address 1<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Address 1"
                        id="address1"
                        value={formData.address1}
                        disabled={isViewMode || isDeleteMode}
                        onChange={handleInputChange}
                      />
                      {!(isViewMode || isDeleteMode) && errors.address1 ? (
                        <span className="error">{errors.address1}</span>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="address2">
                        Address 2<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Address 2"
                        id="address2"
                        value={formData.address2}
                        disabled={isViewMode || isDeleteMode}
                        onChange={handleInputChange}
                      />
                      {!(isViewMode || isDeleteMode) && errors.address2 ? (
                        <span className="error">{errors.address2}</span>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="address3">Address 3</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Address 3"
                        id="address3"
                        value={formData.address3}
                        disabled={isViewMode || isDeleteMode}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="pinCode">
                        Pin Code<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Pin Code"
                        id="pinCode"
                        value={formData.pinCode}
                        disabled={isViewMode || isDeleteMode}
                        maxLength={6}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d{0,6}$/.test(value)) {
                            handleInputChange(e);
                          }
                        }}
                      />
                      {!(isViewMode || isDeleteMode) && errors.pinCode ? (
                        <span className="error">{errors.pinCode}</span>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="state">State</label>
                      <input
                        type="text"
                        className="form-control"
                        id="state"
                        value={formData.state || "State"}
                        style={{ cursor: "not-allowed" }}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="city">City</label>
                      <input
                        type="text"
                        className="form-control"
                        id="city"
                        value={formData.city || "City"}
                        style={{ cursor: "not-allowed" }}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="firstContactPersonName">
                        Contact Person Name 1
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Contact Person Name 1"
                        id="firstContactPersonName"
                        value={formData.firstContactPersonName}
                        disabled={isViewMode || isDeleteMode}
                        onChange={handleInputChange}
                      />
                      {!(isViewMode || isDeleteMode) &&
                      errors.firstContactPersonName ? (
                        <span className="error">
                          {errors.firstContactPersonName}
                        </span>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="firstContactPersonMobileNo">
                        Contact Person 1 Mobile No.
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Contact Person 1 Mobile No."
                        id="firstContactPersonMobileNo"
                        value={formData.firstContactPersonMobileNo}
                        disabled={isViewMode || isDeleteMode}
                        maxLength={10}
                        onChange={(e) => {
                          const value = e.target.value;
                          // Only allow digits and max 10 characters
                          if (/^\d{0,10}$/.test(value)) {
                            handleInputChange(e);
                          }
                        }}
                      />

                      {!(isViewMode || isDeleteMode) &&
                      errors.firstContactPersonMobileNo ? (
                        <span className="error">
                          {errors.firstContactPersonMobileNo}
                        </span>
                      ) : null}
                    </div>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="bankName">
                        Bank Name<span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        id="bankName"
                        className="form-select"
                        value={formData.bankName}
                        disabled={isViewMode || isDeleteMode}
                        onChange={handleInputChange}
                        style={{ appearance: "listbox" }}
                      >
                        <option value="">Select Bank</option>
                        {bankNames?.map((bank) => (
                          <option key={bank.bankId} value={bank.bankName}>
                            {bank.bankName}
                          </option>
                        ))}
                      </select>
                      {!(isViewMode || isDeleteMode) && errors.bankName ? (
                        <span className="error">{errors.bankName}</span>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="accountNo">
                        Account Number<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Account Number"
                        id="accountNo"
                        value={formData.accountNo}
                        disabled={isViewMode || isDeleteMode}
                        maxLength={30}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d{0,30}$/.test(value)) {
                            handleInputChange(e);
                          }
                        }}
                      />
                      {!(isViewMode || isDeleteMode) && errors.accountNo ? (
                        <span className="error">{errors.accountNo}</span>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="ifscCode">
                        IFSC Code<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="IFSC Code"
                        id="ifscCode"
                        value={formData.ifscCode}
                        disabled={isViewMode || isDeleteMode}
                        onChange={handleInputChange}
                      />
                      {!(isViewMode || isDeleteMode) && errors.ifscCode ? (
                        <span className="error">{errors.ifscCode}</span>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="rate">
                        Rate<span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder=""
                        id="rate"
                        value={formData.rate}
                        disabled={isViewMode || isDeleteMode}
                        onChange={handleInputChange}
                        style={{ textAlign: "right" }}
                      />
                      {!(isViewMode || isDeleteMode) && errors.rate ? (
                        <span className="error">{errors.rate}</span>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
              <div className="scoped-modal modal-footer">
                <button
                  type="button"
                  className="btn btn-back"
                  onClick={handleBack}
                >
                  Back
                </button>
                {!isViewMode && !isDeleteMode && (
                  <button type="submit" className="btn btn-submit">
                    {isEditMode ? "Update" : "Submit"}
                  </button>
                )}
                {isDeleteMode && (
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={openModal}
                  >
                    Delete
                  </button>
                )}
                <DeleteFranchiseConfirmationModal
                  isOpen={isModalOpen}
                  onClose={closeModal}
                  editData={editData}
                  fetchCustomerData={fetchCustomerData}
                  handleClose={handleClose}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
      {show && <div className="modal-backdrop fade show"></div>}
    </>
  );
};

export default CustomerModal;
